import React from 'react';

import PageHeader from '../../components/header/page';
import ContentBlock from '../../components/contentblock';
import SidebarNav from '../../components/navigation/sidebar';
import InfoBox from '../../components/navigation/infobox';
import BackgroundImage from '../../resources/images/header/mammografie.jpg';

const MammographiePage = props =>
  (<main>
    <PageHeader headline="Mammographie" image={BackgroundImage} />
    <section className="container-custom split">
      <div className="container-custom">
        <ContentBlock title="Vorbereitungen zu Hause:">
          <ul className="feature-list">
            <li>
              Vermeiden Sie am Tag der Untersuchung <strong>jegliche Form von Hautcremes, Deos oder Puder</strong>.
            </li>
            <li>
              Tragen Sie Kleidung ohne <strong>Metallapplikationen</strong> (Reißverschlüsse, Knöpfe etc.).
            </li>
            <li>
              Legen Sie Ihre <strong>Halsketten</strong> ab.
            </li>
            <li>
              Entfernen Sie <strong>Brustpiercings</strong>.
            </li>
            <li>
              Binden Sie Ihre <strong>Haare</strong> zusammen.
            </li>
            <li>
              Bringen Sie Ihre <strong>Vorbefunde</strong> mit (OP-Berichte, Röntgenbilder etc.).
            </li>
          </ul>
        </ContentBlock>
        <ContentBlock title="Vorbereitungen in der Ordination:">
          <ul className="feature-list">
            <li>
              Füllen Sie in der Ordination das <strong>Anamneseblatt</strong> aus.
            </li>
            <li>
              Durch unsere Mitarbeiter/innen erfolgt eine Aufklärung über das <strong>BKFP</strong> (Brustkrebsfrüherkennungsprogramm).
            </li>
          </ul>
        </ContentBlock>
        <ContentBlock title="Befundsbesprechung:">
          <ul className="feature-list">
            <li>
              Eventuell wird nach der Mammographie noch ein Ultraschall durchgeführt, wenn der Arzt/die Ärztin dies für nötig erachtet.
            </li>
            <li>
              Für die Befundung gilt das 4-Augen-Prinzip: Sie wird durch 2 Ärzte/Ärztinnen vorgenommen und dauert maximal 1 Woche.
            </li>
            <li>
              Der Befund wird per Post an die Patient/innen und an den angegebenen oder überweisenden Arzt/Ärztin übermittelt. 
              Wenn die Patient/innen den Brief nicht innerhalb von 4-6 Wochen erhalten, bitten wir um Kontaktaufnahme mit unserem Institut.
            </li>
          </ul>
        </ContentBlock>
      </div>
      <aside className="sidebar">
            <SidebarNav />
            <InfoBox name="mammographie" />
          </aside>  
    </section>
  </main>);

export default MammographiePage;


// WEBPACK FOOTER //
// ./src/pages/leistungen/mammographie.js